import { Component } from '@angular/core';
import { ProjectService } from '../../../services/project.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from '../../../services/message.service';
import { StoreCoverage, StoreCoverageFilterCriteria } from '../../../models/storecoverage';
import { UserLogin } from '../../../../Common/models/user.login';
import { catchError, of } from 'rxjs';
import { ConfirmationService } from 'primeng/api';

declare var bootstrap: any;

@Component({
  selector: 'app-store-coverage-list',
  templateUrl: './store-coverage-list.component.html',
  styleUrl: './store-coverage-list.component.css'
})

export class StoreCoverageListComponent {

  lstStoreCoverageData: StoreCoverage[] = [];
  templstStoreCoverageData: StoreCoverage[] = [];

  selectedCategoryName?: string;
  selectedStatus?: string;
  txtSearchTitle?: string;
  selectedDateRange: any;
  selectedStartDate1?: string;
  selectedStartDate2?: string;

  categoryList: any[] | undefined = [];
  selectedCategories: any[] = [];
  selectedAction: string = '';
  selectedStoreCoverage: StoreCoverage = new StoreCoverage();
  originalStoreCoverage: StoreCoverage = new StoreCoverage();

  uInfo: UserLogin | null | undefined;

  isFilterApplied: boolean = false;

  constructor(
    private projectService: ProjectService,
    private ngxService: NgxUiLoaderService,
    private msgService: MessageService,
    private confirmationService: ConfirmationService
  ) {

  }

  ngOnInit(): void {
    this.getUserRoleInfo();
    this.getAllCoveragePlan();
    this.getUserRoleInfo();
  }

  ngAfterViewInit() {
    const modalElement = document.getElementById('exampleModal');
    if (modalElement) {
      modalElement.addEventListener('hidden.bs.modal', () => {
        document.body.classList.remove('modal-open');
        document.querySelectorAll('.modal-backdrop')
          .forEach(el => el.remove());
      });
    }
  }

  getAllCoveragePlan() {
    this.ngxService.start();

    this.projectService.getAllStoreCoverageData().subscribe({
      next: (data: StoreCoverage[]) => {
        this.lstStoreCoverageData = data;
        this.templstStoreCoverageData = JSON.parse(JSON.stringify(this.lstStoreCoverageData));
        this.ngxService.stop();
      },
      error: (err: any) => {
        console.error('Error fetching store coverage:', err);
        this.ngxService.stop();
        this.msgService.htmlError('Failed to load store coverage.');
      }
    });
  }

  getUserRoleInfo() {
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {

      this.uInfo = JSON.parse(atob(encodedVal));
      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      this.categoryList = userRoleInfo.categories;
    }
  }

  selectedSubmittedDateRange() {
    if (this.selectedDateRange == null) {
      this.selectedStartDate1 = undefined;
      this.selectedStartDate2 = undefined;
    }
    else if (this.selectedDateRange?.length == 2 && this.selectedDateRange.every((a: any) => a != null)) {
      this.selectedStartDate1 = this.selectedDateRange[0];
      this.selectedStartDate2 = this.selectedDateRange[1];
    }

    this.filteredStoreCoverage();
    this.checkFilterStatus();
  }

  onTitleChange(event: any) {
    this.filteredStoreCoverage();
    this.checkFilterStatus();
  }

  filteredStoreCoverage() {
    let criteria: StoreCoverageFilterCriteria = this.getStoreCoverageFilterCriteria();

    const filterStoreCoverage = this.templstStoreCoverageData.filter(store => {
      const matchesTitle = criteria.title
        ? store.title?.toLowerCase().includes(criteria.title.toLowerCase()) ?? false
        : true;

      const matchesCategory = criteria.categoryName && criteria.categoryName.length > 0
        ? criteria.categoryName.includes(store.categoryName)
        : true;

      const matchesStartDate = (criteria.storeCoverageDate1 && criteria.storeCoverageDate2)
        ? new Date(store.storeCoverageDate ?? 0) >= new Date(criteria.storeCoverageDate1 ?? 0) && new Date(store.storeCoverageDate ?? 0) <= new Date(criteria.storeCoverageDate2 ?? 0)
        : true;

      return matchesTitle && matchesCategory && matchesStartDate;
    });

    this.lstStoreCoverageData = filterStoreCoverage;
  }

  getStoreCoverageFilterCriteria() {

    const criteria: StoreCoverageFilterCriteria = {
      title: this.txtSearchTitle,
      categoryName: this.selectedCategoryName !== '-1' ? this.selectedCategoryName : undefined,
      storeCoverageDate1: this.selectedStartDate1,
      storeCoverageDate2: this.selectedStartDate2
    };

    return criteria;
  }

  editStoreCoverage(store: StoreCoverage) {
    this.selectedStoreCoverage = { ...store };
    this.originalStoreCoverage = { ...store };

    if (this.selectedStoreCoverage.storeCoverageDate) {
      this.selectedStoreCoverage.storeCoverageDate = new Date(this.selectedStoreCoverage.storeCoverageDate);
    }
    this.showAddEditStoreCoverage('EDIT');
  }

  addStoreCoverage() {
    this.selectedStoreCoverage = new StoreCoverage(); // blank object
    this.selectedStoreCoverage.category = 0;
    this.showAddEditStoreCoverage('ADD');
  }

  onSelectedCategory(event: any) {
    const categoryNames = event.map((x: { categoryName: string }) => x.categoryName.trimEnd()).join(',');
    this.selectedCategoryName = categoryNames;
    this.filteredStoreCoverage();
    this.checkFilterStatus();
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  showAddEditStoreCoverage(actionMode: string) {
    this.selectedAction = actionMode;
    //this.isShowStoreCoverageModal = true;

    setTimeout(() => {
      const modalEl = document.getElementById("exampleModal");
      if (modalEl) {
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }
    });
  }

  onSaveSuccess() {
    const modalElement = document.getElementById('exampleModal');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement)
        || new bootstrap.Modal(modalElement);
      modalInstance.hide();
    }

    this.getAllCoveragePlan();
  }

  deleteStoreCoverage(selectedStoreCoverage: StoreCoverage) {

    selectedStoreCoverage.updatedBy = this.uInfo?.userID ?? 0;

    this.confirmationService.confirm({
      header: "Delete Store Coverage",
      message: "Are you sure you want to delete the store coverage?",
      accept: () => {
        this.projectService.UpdateStoreCoverageStatus(selectedStoreCoverage).subscribe(data => {
          this.msgService.htmlSuccess('Store Coverage deleted successfully');
          this.getAllCoveragePlan();
        });
      },
      reject: () => {
      }
    });
  }

  // #region Download Store Coverage Report
  downloadStoreCoverageReportExcel(event: Event, storeCoverageData?: StoreCoverage): void {
    event.preventDefault();
    event.stopPropagation();

    if (!storeCoverageData) {
      return;
    }

    if (storeCoverageData.fileName != null) {
      this.ngxService.start();

      this.projectService.DownloadStoreCoverageReportDocument(storeCoverageData.storeCoverageID, storeCoverageData.fileName)
        .pipe(
          catchError(error => {
            this.ngxService.stop();
            this.msgService.htmlError('Failed to download Store Coverage Report');
            return of<void>();
          })
        )
        .subscribe(data => {
          this.downloadFile(data, storeCoverageData.fileName);
          this.msgService.htmlSuccess('Store Coverage Report file downloaded successfully.');
          this.ngxService.stop();
        });
    }
    else {
      this.msgService.htmlError('Failed to download Store Coverage Report');
      return;
    }

  }

  downloadFile(blob: Blob, fileName: string): void {
    let downloadLink = fileName;
    if (blob) {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = downloadLink;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } else {
      alert('Download link or blob is not set.');
    }
  }
  //#endregion

  clearFilter() {
    this.txtSearchTitle = '';
    this.selectedCategories = [];
    this.selectedCategoryName = '';
    this.selectedDateRange = null;
    this.selectedStartDate1 = undefined;
    this.selectedStartDate2 = undefined;

    this.lstStoreCoverageData = [...this.templstStoreCoverageData];
    this.isFilterApplied = false;
  }

  private checkFilterStatus() {
    this.isFilterApplied =
      !!this.txtSearchTitle ||
      (this.selectedCategories && this.selectedCategories.length > 0) ||
      (this.selectedDateRange && this.selectedDateRange.length > 0);
  }

}
